// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"mi","cardContent":"mj","editButton":"mk","innerHeading":"ml","header":"mm","subHeader":"mn"};